/**
 * Pass as axios config when loading helper/catalog data required by a
 * screen the user already has access to (drawer, form, filter dropdown).
 *
 * Example:
 *   axios.get('/api/equipment', { ...skipPerm, params: { page: 1 } })
 *
 * Never use this for mutations (POST/PUT/PATCH/DELETE) of protected resources.
 */
export const skipPerm = { skipPermissionCheck: true } as const
